import React from 'react';
import { BiSearchAlt2, BiHive, BiCodeAlt } from 'react-icons/bi';

const Services = () => {
  return (
    <div className="service-catalog">
      <div className="workflow-title">
        Build the Context Your AI Needs
      </div>
      <p className="workflow-description">
        Key steps in the work: diagnose → managed knowledge system → deployed engineering.
      </p>
      <p className="workflow-description workflow-learn-more">
        <span className="highlight" onClick={() => { window.location.href = 'mailto:projects@aberrest.com'; }}>
          Contact us to learn more.
        </span>
      </p>
      <ul className="workflow-list">
        <li className="workflow-item">
          <div className="workflow-item-title">
            <BiSearchAlt2 className="workflow-icon" />
            Diagnostic & advisory
          </div>
          <div className="workflow-item-detail">
            Map where investment context is fragmented, what AI can safely use, and what to build first — with clear data boundaries and a walk-away.
          </div>
        </li>
        <li className="workflow-item">
          <div className="workflow-item-title">
            <BiHive className="workflow-icon" />
            Managed knowledge system
          </div>
          <div className="workflow-item-detail">
            A managed system that structures firm data and documents so your AI has durable context for portfolio and operation decisions.
          </div>
        </li>
        <li className="workflow-item">
          <div className="workflow-item-title">
            <BiCodeAlt className="workflow-icon" />
            Deployed engineering
          </div>
          <div className="workflow-item-detail">
            Deployed with your team so the knowledge engine lands on real fund, vehicle, portco, and IC workflows.
          </div>
        </li>
      </ul>
      <div className="workflow-avail">
        <a href="mailto:projects@aberrest.com" className="workflow-cta">Contact us to get started.</a>
      </div>
    </div>
  );
};

export default Services;
